var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var IkPrice = /** @class */ (function () {
    function IkPrice() {
    }
    /**
     *  (number: number | string) easy way to convert a number to a price, use the global configuration (at least currency)
     *  (number: numberToConvert) complexe way, override global configuration with given parameters
     */
    IkPrice.prototype.convert = function (number) {
        if (typeof number === 'number' || typeof number === 'string') {
            number = { amount: +number }; // cannot fail but can give NaN
        }
        var _a = __assign(__assign({}, defaultConfiguration), number), amount = _a.amount, currency = _a.currency, decimals = _a.decimals, textBefore = _a.textBefore, textAfter = _a.textAfter, textUnder = _a.textUnder, textPromotion = _a.textPromotion, currencyDisplay = _a.currencyDisplay, resultDisplay = _a.resultDisplay, style = _a.style, amountDisplay = _a.amountDisplay;
        if (isNaN(amount) || (!amount && amount !== 0)) { // NaN go there
            console.warn('ikPrice failed: no amount given', number);
            this.debug();
            return;
        }
        /**
         * set debug mode to true to inspect result further
         */
        this.debug();
        var currentCommonSettings = commonSettings.format[resultDisplay];
        var currentCurrencySettings = currenciesSettings[currency];
        var price = formatPrice(amount, decimals, currency);
        var prefix = textBefore ? currentCommonSettings.prefix.replace(/{prefix}/gi, textBefore) : '';
        var suffix = textAfter ? currentCommonSettings.suffix.replace(/{suffix}/gi, textAfter) : '';
        var under = textUnder ? currentCommonSettings.under.replace(/{under}/gi, textUnder) : '';
        var promotion = textPromotion ? currentCommonSettings.promotion.replace(/{promotion}/gi, textPromotion) : '';
        var currencyLabel = currentCurrencySettings[currencyDisplay];
        var wrapper = currentCommonSettings.wrapper;
        var endWrapper = currentCommonSettings.endWrapper;
        var underWrapper = currentCommonSettings.underWrapper;
        var endUnderWrapper = currentCommonSettings.endUnderWrapper;
        var main = currentCurrencySettings.format[resultDisplay].replace(/{currency}/gi, currencyLabel).replace(/{amount}/gi, price).replace(/{amountDisplay}/gi, amountDisplay);
        var firstLine = prefix + main + suffix;
        var secondLine = under || promotion ? underWrapper + under + promotion + endUnderWrapper : '';
        return (wrapper + firstLine + secondLine + endWrapper).replace(/{style}/gi, style);
    };
    /**
     * full text
     */
    IkPrice.prototype.convertText = function (text) {
        var wrapper = commonSettings.format.html.wrapper;
        var endWrapper = commonSettings.format.html.endWrapper;
        var underWrapper = commonSettings.format.html.underWrapper;
        var endUnderWrapper = commonSettings.format.html.endUnderWrapper;
        var firstLine = commonSettings.format.html.prefix.replace(/{prefix}/gi, text.firstLine);
        var secondLine = text.secondLine ? underWrapper + text.secondLine + endUnderWrapper : '';
        return (wrapper + firstLine + secondLine + endWrapper).replace(/{style}/gi, text.style);
    };
    /**
     * Initialize the library with default configuration. These settings are set as default value of the convert method
     * You must call init() with pathToStyle to inject given stylesheet in the DOM. Necessary stylesheet can be found in index.css
     * You must care about mimeType imported via the script, it may be not allowed by the server (text/css)
     * If you do not want to inject it using library, you can do it by your side.
     */
    IkPrice.prototype.init = function (configuration, urlToStyle) {
        defaultConfiguration = __assign(__assign({}, defaultConfiguration), configuration);
        // append to dom stylesheet of differents currency style
        if (!urlToStyle) {
            return;
        }
        try {
            var head = document.head || document.getElementsByTagName('head')[0];
            var style = document.createElement('link');
            style.rel = 'stylesheet';
            style.href = urlToStyle;
            style.type = 'text/css';
            head.appendChild(style);
        }
        catch (err) {
            console.error('ikPrice failed: path to style given failed to be loaded', urlToStyle);
        }
        ;
    };
    IkPrice.prototype.debug = function () {
        if (defaultConfiguration.debugMode) {
            console.log('.:ikPrice debugging:.');
            debugger;
        }
    };
    return IkPrice;
}());
export { IkPrice };
var ikPrice = new IkPrice();
export default ikPrice;
/**
 * PRIVATE
 */
var none = '';
var currenciesSettings = {
    chf: {
        id: 1,
        key: 'chf',
        text: 'CHF ',
        sign: 'CHF ',
        none: none,
        format: {
            html: '<span class="ikprice_{style}_currency">{currency}</span><span class="ikprice_{style}_amount_{amountDisplay}">{amount}</span>',
            text: '{currency}{amount}',
        },
        separator: {
            thousand: '\'',
            decimal: '.',
        },
    },
    euro: {
        id: 2,
        key: 'euro',
        text: ' EUR',
        sign: ' €',
        none: none,
        format: {
            html: '<span class="ikprice_{style}_amount_{amountDisplay}">{amount}</span><span class="ikprice_{style}_amount_{amountDisplay}">{currency}</span>',
            text: '{amount}{currency}',
        },
        separator: {
            thousand: ' ',
            decimal: ',',
        },
    }
};
var commonSettings = {
    labels: {
        // TAX
        including: 'TTC',
        excluding: 'HT',
        none: '',
    },
    format: {
        html: {
            prefix: '<span class="ikprice_{style}_prefix">{prefix}</span> ',
            suffix: ' <span class="ikprice_{style}_suffix">{suffix}</span>',
            under: '<span class="ikprice_{style}_under_text">{under}</span>',
            promotion: '<span class="ikprice_{style}_under_promotion">{promotion}</span>',
            wrapper: '<span class="ikprice ikprice_{style}">',
            endWrapper: '</span>',
            underWrapper: '<span class="ikprice ikprice_{style}_under">',
            endUnderWrapper: '</span>',
        },
        text: {
            prefix: '{prefix} ',
            suffix: ' {suffix}',
            under: ' {under}',
            promotion: '',
            wrapper: '',
            endWrapper: '',
            underWrapper: '',
            endUnderWrapper: '',
        }
    }
};
var defaultConfiguration = {
    currency: 'chf',
    decimals: 2,
    currencyDisplay: 'sign',
    debugMode: false,
    resultDisplay: 'html',
    style: 'none',
    amountDisplay: 'big',
};
var formatPrice = function (amount, decimals, currency) {
    var _a = amount.toFixed(decimals).split('.').map(function (number) { return number.toString(); }), int = _a[0], decimal = _a[1];
    var formattedInt = int;
    if (formattedInt.length >= 4) {
        // 1234567
        var reversedInt = reverseString(int);
        // 7654321
        var groups = reversedInt.match(/[\s\S]{1,3}/g) || [];
        // ['765', '432', '1']
        var reorderedGroups = groups.map(function (group) { return reverseString(group); }).reverse();
        // ['1', '234', '567']
        formattedInt = reorderedGroups.join(currenciesSettings[currency].separator.thousand);
        // 1 234 567
    }
    // 1 234 567,98, si decimal === 00 : 1 234 567,00 => 1 234 567
    return decimal && (int.length < 4 || decimal !== '00') ? formattedInt + currenciesSettings[currency].separator.decimal + decimal : formattedInt;
};
var reverseString = function (s) {
    if (s === '')
        return '';
    else
        return reverseString(s.substr(1)) + s.charAt(0);
};
